var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.029,
    height: 20.039,
    viewBox: "0 0 15.029 20.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.359,20.039H1.67A1.672,1.672,0,0,1,0,18.369V7.932a.417.417,0,0,1,.418-.417H1.67V5.845a5.84,5.84,0,0,1,9.694-4.4,5.884,5.884,0,0,1,1.28,1.6A5.8,5.8,0,0,1,13.3,5.027H10.753a3.317,3.317,0,0,0-.441-1A3.357,3.357,0,0,0,8.627,2.7,3.34,3.34,0,0,0,4.175,5.845v1.67h5.5v.008h4.589V7.515h.346a.417.417,0,0,1,.418.417V18.369A1.672,1.672,0,0,1,13.359,20.039ZM7.515,10.854a1.672,1.672,0,0,0-1.623,2.064,1.645,1.645,0,0,0,.349.684,1.674,1.674,0,0,0,.287.265l-.263,2.368a.418.418,0,0,0,.415.464H8.35a.418.418,0,0,0,.415-.464L8.5,13.867a1.674,1.674,0,0,0,.287-.265,1.645,1.645,0,0,0,.349-.684,1.672,1.672,0,0,0-1.623-2.064Z",
    fill: "#697384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicviews);
export default __webpack_public_path__ + "static/media/publicviews.2fc8062a3aad2fd5ec56d2f096b65576.svg";
export { ForwardRef as ReactComponent };